import { Placeholder } from './Placeholder';

export function ActivityTab() {
  return <Placeholder icon="activity" titleKey="tab.activity" noteKey="placeholder.activity" />;
}
